import { useQuery } from '@tanstack/react-query';
import api from './api';

export const useDashboardStats = () =>
  useQuery({
    queryKey: ['dashboard-stats'],
    queryFn: () => api.get('/dashboard/stats').then((res) => res.data),
    staleTime: 1000 * 60 * 1, // 1 minute
  });

